import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React, { useEffect } from 'react';

import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Profile'>;

/**
 * `Profile` stays registered so every existing `navigate('Profile')` call (header, side menu,
 * payment screens) still resolves, but the profile body itself now lives inline in the inventory
 * modal's own tab-switching (`InventoryScreen`), alongside Inventory and Friends - the three used
 * to be three separate modal screens, so switching between them replaced one native-stack screen
 * with another, and on iOS that meant a real modal present/dismiss on every tab tap. Routing here
 * straight into that shared modal, already on the `profile` tab, is a one-time hop rather than
 * something the tabs do on every switch.
 */
const ProfileScreen: React.FC<Props> = ({ navigation, route }) => {
	// `replace`, not `navigate`: this screen renders nothing, so if `Inventory` isn't already in the
	// stack, `navigate` would push a new one on top and leave this blank screen sitting underneath
	// it - closing that Inventory screen would then land back on this one, which renders nothing but
	// (being a screen of its own) still eats every touch, freezing the app. `replace` always swaps
	// this screen out instead of stacking under whatever comes next.
	useEffect(() => {
		navigation.replace('Inventory', { tab: 'profile', edit: route.params?.edit });
	}, [navigation, route.params?.edit]);

	return null;
};

export default ProfileScreen;
